// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox-gS5KP","columnOrientation":"columnOrientation-OV5MB","rowOrientation":"rowOrientation-EjWYa","icon":"icon-JWJ8x","selected":"selected-MpMFa"};